export const ROLES: Record<string, { id: number; name: string; shortName: string }> = {
  all: { id: 0, name: 'All', shortName: 'All' },
  bu: { id: 1, name: 'Betriebsüberwacher', shortName: 'Bü' },
  fdl: { id: 2, name: 'Fahrdienstleiter', shortName: 'FDL' },
  bki: { id: 3, name: 'Betriebliche Kundeninformation', shortName: 'BKI' },
  lf: { id: 4, name: 'Lokführer', shortName: 'LF' },
  zb: { id: 5, name: 'Zugbegleiter', shortName: 'ZB' },
  zv: { id: 6, name: 'Zugvorbereiter', shortName: 'ZV' },
  ad: { id: 7, name: 'Administrator', shortName: 'Ad' },
  embz: { id: 8, name: 'Ereignis Manager BZ', shortName: 'EMBZ' },
};

export const OPS_SUB_ROLES = [
  { label: 'FDL', value: 'fdl' },
  { label: 'Bü', value: 'bu' },
  { label: 'BKI', value: 'bki' },
  { label: 'EMBZ', value: 'embz' },
] as const;

export const USER_ROLES = {
  ops: 'ops',
  qs: 'qs',
  ad: 'ad',
} as const;

export const NOTIFIABLE_ROLES: typeof ROLES = Object.fromEntries(
  Object.entries(ROLES).filter(([key]) => key !== 'ad')
);

export const ALL_RECIPIENT_ROLE_KEYS = Object.keys(NOTIFIABLE_ROLES).filter((key) => key !== 'all');

export const ALL_AVAILABLE_TO_ROLE_KEYS = Object.keys(ROLES).filter((key) => key !== 'all');
